import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";
import type DateRange from "@/core/types/DateRange";
import type DateSimple from "@/core/types/DateSimple";
import type ContractType from "@/domains/Contracts/ContractType";
import type ContractPublic from "@/domains/Contracts/ContractPublic";
import RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import RpcDataSort from "@/core/services/Rpc/RpcDataSort";

/**
 * DAO для работы с публичными офертами
 */
class ContractsPublicDAO {

	static async get(type?: ContractType, version?: number, id?: number): Promise<RpcResponse> {
		return await RpcService.makeRequestSilent('contracts.getPublic', {
			type,
			version,
			id
		});
	}

	static async getList(
    filters?: {
      type?: ContractType,
      version?: number,
      publicationPeriod?: DateRange,
      isActual?: boolean,
      isDraft?: boolean
    },
    pagination?: RpcDataPagination,
    sort?: RpcDataSort
	): Promise<RpcResponse> {
		return await RpcService.makeRequestSilent(
      'contracts.getListPublic',
      {
        ...filters,
        type: filters?.type ? { id: filters.type } : undefined,
		  },
      pagination,
      sort
    );
	}

	static async update(contract: ContractPublic): Promise<RpcResponse> {
		return await RpcService.makeRequestSilent('contracts.updatePublic', { contract });
	}

	static async publish(type: ContractType, publicationDate: DateSimple): Promise<RpcResponse> {
		return await RpcService.makeRequestSilent('contracts.publishPublic', {
			type,
			publicationDate
		});
	}

	static async accept(contracts: ContractPublic[]): Promise<RpcResponse> {
		return await RpcService.makeRequestSilent('contracts.acceptPublic', { contracts });
	}

	static async getPdf(type: ContractType, version: number): Promise<RpcResponse> {
		return await RpcService.makeRequestSilent('contracts.getPdfPublic', {
			type,
			version
		});
	}
}

export default ContractsPublicDAO;
